/* eslint-disable func-style */
const RightPanel = () => import('../components/RightPanel');
const importDsfInfo = () => import('../pages/Dsf/ImportDsfInfo');
const DsfDetail = () => import('../pages/Dsf/DsfDetail');
const ImportNewDsf = () => import('../pages/Dsf/ImporNewDsf');
const DsfSettlement = () => import('../pages/Dsf/DsfSettlement');
const DsfSettleByYear = () => import('../pages/Dsf/DsfSettleByYear');
const ImportRefundInfo = () => import('../pages/Dsf/ImportRefundInfo');
const SettleRecord = () => import('../pages/Dsf/SettleRecord');

export default [
	{
		name: 'SettleRecord',
		path: '/SettleRecord',
		component: SettleRecord,
		children: [
			{
				path: '/SettlementRecordDetailRightPanel',
				name: 'SettlementRecordDetailRightPanel',
				component: RightPanel,
				children: [
					{
						path: '/SettleRecordDetail/:rowData',
						name: 'SettleRecordDetail',
						component: () => import('@/pages/Dsf/SettleRecordDetail'),
						meta: { parent: '/SettleRecord' },
					},
				],
			},
		],
	},
	{
		name: 'imporDsfInfo',
		path: '/importDsfInfo',
		component: importDsfInfo,
	},
	{
		name: 'DsfDetail',
		path: '/DsfDetail/:id',
		component: DsfDetail,
	},
	{
		name: 'ImportNewDsf',
		path: '/ImportNewDsf',
		component: ImportNewDsf,
	},
	{
		name: 'ImportAppendDsf',
		path: '/ImportAppendDsf/:pc_id',
		component: ImportNewDsf,
	},
	{
		name: 'DsfSettlement',
		path: '/DsfSettlement',
		component: DsfSettlement,
		children: [
			{
				path: '/SettlementRightPanel',
				name: 'SettlementRightPanel',
				component: RightPanel,
				children: [
					{
						path: '/SettlementDetail/:rowData',
						name: 'SettlementDetail',
						component: () => import('@/pages/Dsf/SettlementDetail'),
						meta: { parent: '/DsfSettlement' },
					},
				],
			},
		],
	},
	{
		name: 'DsfSettleByYear',
		path: '/DsfSettleByYear',
		component: DsfSettleByYear,
		children: [
			{
				path: '/SettlementRightPanel1',
				name: 'SettlementRightPanel1',
				component: RightPanel,
				children: [
					{
						path: '/SettlementDetail1/:rowData',
						name: 'SettlementDetail1',
						component: () => import('@/pages/Dsf/SettlementDetail'),
						meta: { parent: '/DsfSettleByYear' },
					},
				],
			},
		],
	},
	{
		name: 'ImportRefundInfo',
		path: '/ImportRefundInfo',
		component: ImportRefundInfo,
	},
];
